export default __webpack_public_path__ + "static/media/pictogramBeaconDebtConsolidation64.376d6895.svg";